import { tv } from 'tailwind-variants';

const radioButtonStyles = tv({
    slots: {
        base: `
      iris:flex
      iris:size-(--comp-size-box-check-radio-control)
      iris:flex-shrink-0
      iris:cursor-pointer
      iris:items-center
      iris:justify-center
      iris:rounded-(--comp-size-radius-radio-control)
      iris:border-(length:--comp-size-border-check-radio-control)
      iris:transition-all
      iris:duration-(--comp-motion-duration-check-radio)
      iris:ease-(--comp-motion-easing-check-radio)
      iris:focus-visible:ring-2
      iris:focus-visible:ring-offset-2
      iris:focus-visible:outline-none
    `,
        indicator: `
      iris:h-[50%]
      iris:w-[50%]
      iris:rounded-(--comp-size-radius-radio-control)
      iris:bg-(--comp-color-background-check-radio-control-selected)
    `,
    },
    variants: {
        inverse: {
            false: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-rest)
          iris:bg-(--comp-color-background-check-radio-control-rest)
          iris:group-data-[state=checked]:border-(--comp-color-border-check-radio-control-selected)
          iris:group-data-[state=checked]:bg-(--comp-color-background-check-radio-control-rest)
        `,
                indicator: "iris:bg-(--comp-color-background-check-radio-control-selected)",
            },
            true: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-inverse-rest)
          iris:bg-(--comp-color-background-check-radio-control-inverse-rest)
          iris:group-data-[state=checked]:border-(--comp-color-border-check-radio-control-inverse-selected)
          iris:group-data-[state=checked]:bg-(--comp-color-background-check-radio-control-inverse-rest)
        `,
                indicator: "iris:bg-(--comp-color-background-check-radio-control-inverse-selected)",
            },
        },
        error: {
            true: "",
            false: "",
        },
        disabled: {
            true: {
                base: `
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
            },
            false: {},
        },
    },
    compoundVariants: [
        {
            inverse: false,
            disabled: false,
            class: {
                base: `
          iris:group-hover:border-(--comp-color-border-check-radio-control-hover)
          iris:group-hover:bg-(--comp-color-background-check-radio-control-hover)
        `,
            },
        },
        {
            inverse: true,
            disabled: false,
            class: {
                base: `
          iris:group-hover:border-(--comp-color-border-check-radio-control-inverse-hover)
          iris:group-hover:bg-(--comp-color-background-check-radio-control-inverse-hover)
        `,
            },
        },
        {
            disabled: true,
            inverse: false,
            class: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-rest)
          iris:bg-(--comp-color-background-check-radio-control-rest)
        `,
            },
        },
        {
            disabled: true,
            inverse: true,
            class: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-inverse-rest)
          iris:bg-(--comp-color-background-check-radio-control-inverse-rest)
        `,
            },
        },
    ],
});

export { radioButtonStyles as default };
